module.exports = __webpack_public_path__ + "img/ad.0a98619c.jpg";